import { UserProfile } from '@clerk/clerk-react';
import AccountShellLayout from '@/app/layout/AccountShellLayout';

const AccountPage = () => {
  return (
    <AccountShellLayout>
      <div className="account-page">
        <UserProfile routing="path" path="/account" />
      </div>
    </AccountShellLayout>
  );
};

export default AccountPage;
